import { j as re } from "./jsx-runtime-DmTjM30f.mjs";
import St, { createContext as wo, useState as j, useRef as it, useEffect as C, useContext as go, useCallback as bo, useImperativeHandle as xo, useLayoutEffect as _o } from "react";
import { I as Ao } from "./ic_close-BJ5TqFBV.mjs";
import { c as He } from "./tw-cn-mXgPecoF.mjs";
import { I as Eo } from "./icon-button-DImUgRzQ.mjs";
function So(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
const Wt = Math.min, Ot = Math.max, ye = Math.round, ve = Math.floor, ft = (t) => ({
  x: t,
  y: t
}), Oo = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ro = {
  start: "end",
  end: "start"
};
function Ce(t, e, o) {
  return Ot(t, Wt(e, o));
}
function le(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Rt(t) {
  return t.split("-")[0];
}
function se(t) {
  return t.split("-")[1];
}
function no(t) {
  return t === "x" ? "y" : "x";
}
function Pe(t) {
  return t === "y" ? "height" : "width";
}
function Ft(t) {
  return ["top", "bottom"].includes(Rt(t)) ? "y" : "x";
}
function je(t) {
  return no(Ft(t));
}
function To(t, e, o) {
  o === void 0 && (o = !1);
  const n = se(t), i = je(t), r = Pe(i);
  let l = i === "x" ? n === (o ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (l = we(l)), [l, we(l)];
}
function Co(t) {
  const e = we(t);
  return [Le(t), e, Le(e)];
}
function Le(t) {
  return t.replace(/start|end/g, (e) => Ro[e]);
}
function Lo(t, e, o) {
  const n = ["left", "right"], i = ["right", "left"], r = ["top", "bottom"], l = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return o ? e ? i : n : e ? n : i;
    case "left":
    case "right":
      return e ? r : l;
    default:
      return [];
  }
}
function ko(t, e, o, n) {
  const i = se(t);
  let r = Lo(Rt(t), o === "start", n);
  return i && (r = r.map((l) => l + "-" + i), e && (r = r.concat(r.map(Le)))), r;
}
function we(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Oo[e]);
}
function No(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function ro(t) {
  return typeof t != "number" ? No(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function ge(t) {
  const {
    x: e,
    y: o,
    width: n,
    height: i
  } = t;
  return {
    width: n,
    height: i,
    top: o,
    left: e,
    right: e + n,
    bottom: o + i,
    x: e,
    y: o
  };
}
function qe(t, e, o) {
  let {
    reference: n,
    floating: i
  } = t;
  const r = Ft(e), l = je(e), s = Pe(l), c = Rt(e), a = r === "y", p = n.x + n.width / 2 - i.width / 2, f = n.y + n.height / 2 - i.height / 2, w = n[s] / 2 - i[s] / 2;
  let d;
  switch (c) {
    case "top":
      d = {
        x: p,
        y: n.y - i.height
      };
      break;
    case "bottom":
      d = {
        x: p,
        y: n.y + n.height
      };
      break;
    case "right":
      d = {
        x: n.x + n.width,
        y: f
      };
      break;
    case "left":
      d = {
        x: n.x - i.width,
        y: f
      };
      break;
    default:
      d = {
        x: n.x,
        y: n.y
      };
  }
  switch (se(e)) {
    case "start":
      d[l] -= w * (o && a ? -1 : 1);
      break;
    case "end":
      d[l] += w * (o && a ? -1 : 1);
      break;
  }
  return d;
}
const Do = async (t, e, o) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: l
  } = o, s = r.filter(Boolean), c = await (l.isRTL == null ? void 0 : l.isRTL(e));
  let a = await l.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: p,
    y: f
  } = qe(a, n, c), w = n, d = {}, m = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: x,
      fn: g
    } = s[v], {
      x: _,
      y: A,
      data: R,
      reset: S
    } = await g({
      x: p,
      y: f,
      initialPlacement: n,
      placement: w,
      strategy: i,
      middlewareData: d,
      rects: a,
      platform: l,
      elements: {
        reference: t,
        floating: e
      }
    });
    p = _ ?? p, f = A ?? f, d = {
      ...d,
      [x]: {
        ...d[x],
        ...R
      }
    }, S && m <= 50 && (m++, typeof S == "object" && (S.placement && (w = S.placement), S.rects && (a = S.rects === !0 ? await l.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : S.rects), {
      x: p,
      y: f
    } = qe(a, w, c)), v = -1);
  }
  return {
    x: p,
    y: f,
    placement: w,
    strategy: i,
    middlewareData: d
  };
};
async function io(t, e) {
  var o;
  e === void 0 && (e = {});
  const {
    x: n,
    y: i,
    platform: r,
    rects: l,
    elements: s,
    strategy: c
  } = t, {
    boundary: a = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: f = "floating",
    altBoundary: w = !1,
    padding: d = 0
  } = le(e, t), m = ro(d), x = s[w ? f === "floating" ? "reference" : "floating" : f], g = ge(await r.getClippingRect({
    element: (o = await (r.isElement == null ? void 0 : r.isElement(x))) == null || o ? x : x.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(s.floating)),
    boundary: a,
    rootBoundary: p,
    strategy: c
  })), _ = f === "floating" ? {
    x: n,
    y: i,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, A = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(s.floating)), R = await (r.isElement == null ? void 0 : r.isElement(A)) ? await (r.getScale == null ? void 0 : r.getScale(A)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = ge(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: _,
    offsetParent: A,
    strategy: c
  }) : _);
  return {
    top: (g.top - S.top + m.top) / R.y,
    bottom: (S.bottom - g.bottom + m.bottom) / R.y,
    left: (g.left - S.left + m.left) / R.x,
    right: (S.right - g.right + m.right) / R.x
  };
}
const Po = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: o,
      y: n,
      placement: i,
      rects: r,
      platform: l,
      elements: s,
      middlewareData: c
    } = e, {
      element: a,
      padding: p = 0
    } = le(t, e) || {};
    if (a == null)
      return {};
    const f = ro(p), w = {
      x: o,
      y: n
    }, d = je(i), m = Pe(d), v = await l.getDimensions(a), x = d === "y", g = x ? "top" : "left", _ = x ? "bottom" : "right", A = x ? "clientHeight" : "clientWidth", R = r.reference[m] + r.reference[d] - w[d] - r.floating[m], S = w[d] - r.reference[d], q = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(a));
    let N = q ? q[A] : 0;
    (!N || !await (l.isElement == null ? void 0 : l.isElement(q))) && (N = s.floating[A] || r.floating[m]);
    const Q = R / 2 - S / 2, K = N / 2 - v[m] / 2 - 1, Z = Wt(f[g], K), ct = Wt(f[_], K), G = Z, at = N - v[m] - ct, T = N / 2 - v[m] / 2 + Q, X = Ce(G, T, at), F = !c.arrow && se(i) != null && T !== X && r.reference[m] / 2 - (T < G ? Z : ct) - v[m] / 2 < 0, I = F ? T < G ? T - G : T - at : 0;
    return {
      [d]: w[d] + I,
      data: {
        [d]: X,
        centerOffset: T - X - I,
        ...F && {
          alignmentOffset: I
        }
      },
      reset: F
    };
  }
}), jo = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var o, n;
      const {
        placement: i,
        middlewareData: r,
        rects: l,
        initialPlacement: s,
        platform: c,
        elements: a
      } = e, {
        mainAxis: p = !0,
        crossAxis: f = !0,
        fallbackPlacements: w,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: v = !0,
        ...x
      } = le(t, e);
      if ((o = r.arrow) != null && o.alignmentOffset)
        return {};
      const g = Rt(i), _ = Ft(s), A = Rt(s) === s, R = await (c.isRTL == null ? void 0 : c.isRTL(a.floating)), S = w || (A || !v ? [we(s)] : Co(s)), q = m !== "none";
      !w && q && S.push(...ko(s, v, m, R));
      const N = [s, ...S], Q = await io(e, x), K = [];
      let Z = ((n = r.flip) == null ? void 0 : n.overflows) || [];
      if (p && K.push(Q[g]), f) {
        const T = To(i, l, R);
        K.push(Q[T[0]], Q[T[1]]);
      }
      if (Z = [...Z, {
        placement: i,
        overflows: K
      }], !K.every((T) => T <= 0)) {
        var ct, G;
        const T = (((ct = r.flip) == null ? void 0 : ct.index) || 0) + 1, X = N[T];
        if (X)
          return {
            data: {
              index: T,
              overflows: Z
            },
            reset: {
              placement: X
            }
          };
        let F = (G = Z.filter((I) => I.overflows[0] <= 0).sort((I, D) => I.overflows[1] - D.overflows[1])[0]) == null ? void 0 : G.placement;
        if (!F)
          switch (d) {
            case "bestFit": {
              var at;
              const I = (at = Z.filter((D) => {
                if (q) {
                  const z = Ft(D.placement);
                  return z === _ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  z === "y";
                }
                return !0;
              }).map((D) => [D.placement, D.overflows.filter((z) => z > 0).reduce((z, ht) => z + ht, 0)]).sort((D, z) => D[1] - z[1])[0]) == null ? void 0 : at[0];
              I && (F = I);
              break;
            }
            case "initialPlacement":
              F = s;
              break;
          }
        if (i !== F)
          return {
            reset: {
              placement: F
            }
          };
      }
      return {};
    }
  };
};
async function $o(t, e) {
  const {
    placement: o,
    platform: n,
    elements: i
  } = t, r = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), l = Rt(o), s = se(o), c = Ft(o) === "y", a = ["left", "top"].includes(l) ? -1 : 1, p = r && c ? -1 : 1, f = le(e, t);
  let {
    mainAxis: w,
    crossAxis: d,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof m == "number" && (d = s === "end" ? m * -1 : m), c ? {
    x: d * p,
    y: w * a
  } : {
    x: w * a,
    y: d * p
  };
}
const Bo = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var o, n;
      const {
        x: i,
        y: r,
        placement: l,
        middlewareData: s
      } = e, c = await $o(e, t);
      return l === ((o = s.offset) == null ? void 0 : o.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: i + c.x,
        y: r + c.y,
        data: {
          ...c,
          placement: l
        }
      };
    }
  };
}, Io = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: o,
        y: n,
        placement: i
      } = e, {
        mainAxis: r = !0,
        crossAxis: l = !1,
        limiter: s = {
          fn: (x) => {
            let {
              x: g,
              y: _
            } = x;
            return {
              x: g,
              y: _
            };
          }
        },
        ...c
      } = le(t, e), a = {
        x: o,
        y: n
      }, p = await io(e, c), f = Ft(Rt(i)), w = no(f);
      let d = a[w], m = a[f];
      if (r) {
        const x = w === "y" ? "top" : "left", g = w === "y" ? "bottom" : "right", _ = d + p[x], A = d - p[g];
        d = Ce(_, d, A);
      }
      if (l) {
        const x = f === "y" ? "top" : "left", g = f === "y" ? "bottom" : "right", _ = m + p[x], A = m - p[g];
        m = Ce(_, m, A);
      }
      const v = s.fn({
        ...e,
        [w]: d,
        [f]: m
      });
      return {
        ...v,
        data: {
          x: v.x - o,
          y: v.y - n,
          enabled: {
            [w]: r,
            [f]: l
          }
        }
      };
    }
  };
};
function be() {
  return typeof window < "u";
}
function Vt(t) {
  return lo(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function J(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function mt(t) {
  var e;
  return (e = (lo(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function lo(t) {
  return be() ? t instanceof Node || t instanceof J(t).Node : !1;
}
function lt(t) {
  return be() ? t instanceof Element || t instanceof J(t).Element : !1;
}
function pt(t) {
  return be() ? t instanceof HTMLElement || t instanceof J(t).HTMLElement : !1;
}
function Ke(t) {
  return !be() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof J(t).ShadowRoot;
}
function ce(t) {
  const {
    overflow: e,
    overflowX: o,
    overflowY: n,
    display: i
  } = st(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + o) && !["inline", "contents"].includes(i);
}
function Mo(t) {
  return ["table", "td", "th"].includes(Vt(t));
}
function xe(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function $e(t) {
  const e = Be(), o = lt(t) ? st(t) : t;
  return o.transform !== "none" || o.perspective !== "none" || (o.containerType ? o.containerType !== "normal" : !1) || !e && (o.backdropFilter ? o.backdropFilter !== "none" : !1) || !e && (o.filter ? o.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (o.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (o.contain || "").includes(n));
}
function Wo(t) {
  let e = bt(t);
  for (; pt(e) && !zt(e); ) {
    if ($e(e))
      return e;
    if (xe(e))
      return null;
    e = bt(e);
  }
  return null;
}
function Be() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function zt(t) {
  return ["html", "body", "#document"].includes(Vt(t));
}
function st(t) {
  return J(t).getComputedStyle(t);
}
function _e(t) {
  return lt(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function bt(t) {
  if (Vt(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Ke(t) && t.host || // Fallback.
    mt(t)
  );
  return Ke(e) ? e.host : e;
}
function so(t) {
  const e = bt(t);
  return zt(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : pt(e) && ce(e) ? e : so(e);
}
function ie(t, e, o) {
  var n;
  e === void 0 && (e = []), o === void 0 && (o = !0);
  const i = so(t), r = i === ((n = t.ownerDocument) == null ? void 0 : n.body), l = J(i);
  if (r) {
    const s = ke(l);
    return e.concat(l, l.visualViewport || [], ce(i) ? i : [], s && o ? ie(s) : []);
  }
  return e.concat(i, ie(i, [], o));
}
function ke(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function co(t) {
  const e = st(t);
  let o = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const i = pt(t), r = i ? t.offsetWidth : o, l = i ? t.offsetHeight : n, s = ye(o) !== r || ye(n) !== l;
  return s && (o = r, n = l), {
    width: o,
    height: n,
    $: s
  };
}
function Ie(t) {
  return lt(t) ? t : t.contextElement;
}
function Mt(t) {
  const e = Ie(t);
  if (!pt(e))
    return ft(1);
  const o = e.getBoundingClientRect(), {
    width: n,
    height: i,
    $: r
  } = co(e);
  let l = (r ? ye(o.width) : o.width) / n, s = (r ? ye(o.height) : o.height) / i;
  return (!l || !Number.isFinite(l)) && (l = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: l,
    y: s
  };
}
const Fo = /* @__PURE__ */ ft(0);
function ao(t) {
  const e = J(t);
  return !Be() || !e.visualViewport ? Fo : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function zo(t, e, o) {
  return e === void 0 && (e = !1), !o || e && o !== J(t) ? !1 : e;
}
function Tt(t, e, o, n) {
  e === void 0 && (e = !1), o === void 0 && (o = !1);
  const i = t.getBoundingClientRect(), r = Ie(t);
  let l = ft(1);
  e && (n ? lt(n) && (l = Mt(n)) : l = Mt(t));
  const s = zo(r, o, n) ? ao(r) : ft(0);
  let c = (i.left + s.x) / l.x, a = (i.top + s.y) / l.y, p = i.width / l.x, f = i.height / l.y;
  if (r) {
    const w = J(r), d = n && lt(n) ? J(n) : n;
    let m = w, v = ke(m);
    for (; v && n && d !== m; ) {
      const x = Mt(v), g = v.getBoundingClientRect(), _ = st(v), A = g.left + (v.clientLeft + parseFloat(_.paddingLeft)) * x.x, R = g.top + (v.clientTop + parseFloat(_.paddingTop)) * x.y;
      c *= x.x, a *= x.y, p *= x.x, f *= x.y, c += A, a += R, m = J(v), v = ke(m);
    }
  }
  return ge({
    width: p,
    height: f,
    x: c,
    y: a
  });
}
function Me(t, e) {
  const o = _e(t).scrollLeft;
  return e ? e.left + o : Tt(mt(t)).left + o;
}
function uo(t, e, o) {
  o === void 0 && (o = !1);
  const n = t.getBoundingClientRect(), i = n.left + e.scrollLeft - (o ? 0 : (
    // RTL <body> scrollbar.
    Me(t, n)
  )), r = n.top + e.scrollTop;
  return {
    x: i,
    y: r
  };
}
function Vo(t) {
  let {
    elements: e,
    rect: o,
    offsetParent: n,
    strategy: i
  } = t;
  const r = i === "fixed", l = mt(n), s = e ? xe(e.floating) : !1;
  if (n === l || s && r)
    return o;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = ft(1);
  const p = ft(0), f = pt(n);
  if ((f || !f && !r) && ((Vt(n) !== "body" || ce(l)) && (c = _e(n)), pt(n))) {
    const d = Tt(n);
    a = Mt(n), p.x = d.x + n.clientLeft, p.y = d.y + n.clientTop;
  }
  const w = l && !f && !r ? uo(l, c, !0) : ft(0);
  return {
    width: o.width * a.x,
    height: o.height * a.y,
    x: o.x * a.x - c.scrollLeft * a.x + p.x + w.x,
    y: o.y * a.y - c.scrollTop * a.y + p.y + w.y
  };
}
function Ho(t) {
  return Array.from(t.getClientRects());
}
function qo(t) {
  const e = mt(t), o = _e(t), n = t.ownerDocument.body, i = Ot(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), r = Ot(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let l = -o.scrollLeft + Me(t);
  const s = -o.scrollTop;
  return st(n).direction === "rtl" && (l += Ot(e.clientWidth, n.clientWidth) - i), {
    width: i,
    height: r,
    x: l,
    y: s
  };
}
function Ko(t, e) {
  const o = J(t), n = mt(t), i = o.visualViewport;
  let r = n.clientWidth, l = n.clientHeight, s = 0, c = 0;
  if (i) {
    r = i.width, l = i.height;
    const a = Be();
    (!a || a && e === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: r,
    height: l,
    x: s,
    y: c
  };
}
function Xo(t, e) {
  const o = Tt(t, !0, e === "fixed"), n = o.top + t.clientTop, i = o.left + t.clientLeft, r = pt(t) ? Mt(t) : ft(1), l = t.clientWidth * r.x, s = t.clientHeight * r.y, c = i * r.x, a = n * r.y;
  return {
    width: l,
    height: s,
    x: c,
    y: a
  };
}
function Xe(t, e, o) {
  let n;
  if (e === "viewport")
    n = Ko(t, o);
  else if (e === "document")
    n = qo(mt(t));
  else if (lt(e))
    n = Xo(e, o);
  else {
    const i = ao(t);
    n = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return ge(n);
}
function fo(t, e) {
  const o = bt(t);
  return o === e || !lt(o) || zt(o) ? !1 : st(o).position === "fixed" || fo(o, e);
}
function Yo(t, e) {
  const o = e.get(t);
  if (o)
    return o;
  let n = ie(t, [], !1).filter((s) => lt(s) && Vt(s) !== "body"), i = null;
  const r = st(t).position === "fixed";
  let l = r ? bt(t) : t;
  for (; lt(l) && !zt(l); ) {
    const s = st(l), c = $e(l);
    !c && s.position === "fixed" && (i = null), (r ? !c && !i : !c && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || ce(l) && !c && fo(t, l)) ? n = n.filter((p) => p !== l) : i = s, l = bt(l);
  }
  return e.set(t, n), n;
}
function Uo(t) {
  let {
    element: e,
    boundary: o,
    rootBoundary: n,
    strategy: i
  } = t;
  const l = [...o === "clippingAncestors" ? xe(e) ? [] : Yo(e, this._c) : [].concat(o), n], s = l[0], c = l.reduce((a, p) => {
    const f = Xe(e, p, i);
    return a.top = Ot(f.top, a.top), a.right = Wt(f.right, a.right), a.bottom = Wt(f.bottom, a.bottom), a.left = Ot(f.left, a.left), a;
  }, Xe(e, s, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Jo(t) {
  const {
    width: e,
    height: o
  } = co(t);
  return {
    width: e,
    height: o
  };
}
function Qo(t, e, o) {
  const n = pt(e), i = mt(e), r = o === "fixed", l = Tt(t, !0, r, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = ft(0);
  if (n || !n && !r)
    if ((Vt(e) !== "body" || ce(i)) && (s = _e(e)), n) {
      const w = Tt(e, !0, r, e);
      c.x = w.x + e.clientLeft, c.y = w.y + e.clientTop;
    } else i && (c.x = Me(i));
  const a = i && !n && !r ? uo(i, s) : ft(0), p = l.left + s.scrollLeft - c.x - a.x, f = l.top + s.scrollTop - c.y - a.y;
  return {
    x: p,
    y: f,
    width: l.width,
    height: l.height
  };
}
function Re(t) {
  return st(t).position === "static";
}
function Ye(t, e) {
  if (!pt(t) || st(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let o = t.offsetParent;
  return mt(t) === o && (o = o.ownerDocument.body), o;
}
function po(t, e) {
  const o = J(t);
  if (xe(t))
    return o;
  if (!pt(t)) {
    let i = bt(t);
    for (; i && !zt(i); ) {
      if (lt(i) && !Re(i))
        return i;
      i = bt(i);
    }
    return o;
  }
  let n = Ye(t, e);
  for (; n && Mo(n) && Re(n); )
    n = Ye(n, e);
  return n && zt(n) && Re(n) && !$e(n) ? o : n || Wo(t) || o;
}
const Zo = async function(t) {
  const e = this.getOffsetParent || po, o = this.getDimensions, n = await o(t.floating);
  return {
    reference: Qo(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Go(t) {
  return st(t).direction === "rtl";
}
const tn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Vo,
  getDocumentElement: mt,
  getClippingRect: Uo,
  getOffsetParent: po,
  getElementRects: Zo,
  getClientRects: Ho,
  getDimensions: Jo,
  getScale: Mt,
  isElement: lt,
  isRTL: Go
};
function en(t, e) {
  let o = null, n;
  const i = mt(t);
  function r() {
    var s;
    clearTimeout(n), (s = o) == null || s.disconnect(), o = null;
  }
  function l(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), r();
    const {
      left: a,
      top: p,
      width: f,
      height: w
    } = t.getBoundingClientRect();
    if (s || e(), !f || !w)
      return;
    const d = ve(p), m = ve(i.clientWidth - (a + f)), v = ve(i.clientHeight - (p + w)), x = ve(a), _ = {
      rootMargin: -d + "px " + -m + "px " + -v + "px " + -x + "px",
      threshold: Ot(0, Wt(1, c)) || 1
    };
    let A = !0;
    function R(S) {
      const q = S[0].intersectionRatio;
      if (q !== c) {
        if (!A)
          return l();
        q ? l(!1, q) : n = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      A = !1;
    }
    try {
      o = new IntersectionObserver(R, {
        ..._,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(R, _);
    }
    o.observe(t);
  }
  return l(!0), r;
}
function on(t, e, o, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, a = Ie(t), p = i || r ? [...a ? ie(a) : [], ...ie(e)] : [];
  p.forEach((g) => {
    i && g.addEventListener("scroll", o, {
      passive: !0
    }), r && g.addEventListener("resize", o);
  });
  const f = a && s ? en(a, o) : null;
  let w = -1, d = null;
  l && (d = new ResizeObserver((g) => {
    let [_] = g;
    _ && _.target === a && d && (d.unobserve(e), cancelAnimationFrame(w), w = requestAnimationFrame(() => {
      var A;
      (A = d) == null || A.observe(e);
    })), o();
  }), a && !c && d.observe(a), d.observe(e));
  let m, v = c ? Tt(t) : null;
  c && x();
  function x() {
    const g = Tt(t);
    v && (g.x !== v.x || g.y !== v.y || g.width !== v.width || g.height !== v.height) && o(), v = g, m = requestAnimationFrame(x);
  }
  return o(), () => {
    var g;
    p.forEach((_) => {
      i && _.removeEventListener("scroll", o), r && _.removeEventListener("resize", o);
    }), f == null || f(), (g = d) == null || g.disconnect(), d = null, c && cancelAnimationFrame(m);
  };
}
const nn = Bo, rn = Io, ln = jo, sn = Po, Ue = (t, e, o) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: tn,
    ...o
  }, r = {
    ...i.platform,
    _c: n
  };
  return Do(t, e, {
    ...i,
    platform: r
  });
};
var mo = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function o() {
      for (var r = "", l = 0; l < arguments.length; l++) {
        var s = arguments[l];
        s && (r = i(r, n(s)));
      }
      return r;
    }
    function n(r) {
      if (typeof r == "string" || typeof r == "number")
        return r;
      if (typeof r != "object")
        return "";
      if (Array.isArray(r))
        return o.apply(null, r);
      if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
        return r.toString();
      var l = "";
      for (var s in r)
        e.call(r, s) && r[s] && (l = i(l, s));
      return l;
    }
    function i(r, l) {
      return l ? r ? r + " " + l : r + l : r;
    }
    t.exports ? (o.default = o, t.exports = o) : window.classNames = o;
  })();
})(mo);
var cn = mo.exports;
const Ne = /* @__PURE__ */ So(cn);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const an = "react-tooltip-core-styles", un = "react-tooltip-base-styles", Je = { core: !1, base: !1 };
function Qe({ css: t, id: e = un, type: o = "base", ref: n }) {
  var i, r;
  if (!t || typeof document > "u" || Je[o] || o === "core" && typeof process < "u" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_CORE_STYLES) || o !== "base" && typeof process < "u" && (!((r = process == null ? void 0 : process.env) === null || r === void 0) && r.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  o === "core" && (e = an), n || (n = {});
  const { insertAt: l } = n;
  if (document.getElementById(e)) return;
  const s = document.head || document.getElementsByTagName("head")[0], c = document.createElement("style");
  c.id = e, c.type = "text/css", l === "top" && s.firstChild ? s.insertBefore(c, s.firstChild) : s.appendChild(c), c.styleSheet ? c.styleSheet.cssText = t : c.appendChild(document.createTextNode(t)), Je[o] = !0;
}
const Ze = async ({ elementReference: t = null, tooltipReference: e = null, tooltipArrowReference: o = null, place: n = "top", offset: i = 10, strategy: r = "absolute", middlewares: l = [nn(Number(i)), ln({ fallbackAxisSideDirection: "start" }), rn({ padding: 5 })], border: s }) => {
  if (!t) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: n };
  if (e === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: n };
  const c = l;
  return o ? (c.push(sn({ element: o, padding: 5 })), Ue(t, e, { placement: n, strategy: r, middleware: c }).then(({ x: a, y: p, placement: f, middlewareData: w }) => {
    var d, m;
    const v = { left: `${a}px`, top: `${p}px`, border: s }, { x, y: g } = (d = w.arrow) !== null && d !== void 0 ? d : { x: 0, y: 0 }, _ = (m = { top: "bottom", right: "left", bottom: "top", left: "right" }[f.split("-")[0]]) !== null && m !== void 0 ? m : "bottom", A = s && { borderBottom: s, borderRight: s };
    let R = 0;
    if (s) {
      const S = `${s}`.match(/(\d+)px/);
      R = S != null && S[1] ? Number(S[1]) : 1;
    }
    return { tooltipStyles: v, tooltipArrowStyles: { left: x != null ? `${x}px` : "", top: g != null ? `${g}px` : "", right: "", bottom: "", ...A, [_]: `-${4 + R}px` }, place: f };
  })) : Ue(t, e, { placement: "bottom", strategy: r, middleware: c }).then(({ x: a, y: p, placement: f }) => ({ tooltipStyles: { left: `${a}px`, top: `${p}px` }, tooltipArrowStyles: {}, place: f }));
}, Ge = (t, e) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(t, e), to = (t, e, o) => {
  let n = null;
  const i = function(...r) {
    const l = () => {
      n = null;
    };
    !n && (t.apply(this, r), n = setTimeout(l, e));
  };
  return i.cancel = () => {
    n && (clearTimeout(n), n = null);
  }, i;
}, eo = (t) => t !== null && !Array.isArray(t) && typeof t == "object", De = (t, e) => {
  if (t === e) return !0;
  if (Array.isArray(t) && Array.isArray(e)) return t.length === e.length && t.every((i, r) => De(i, e[r]));
  if (Array.isArray(t) !== Array.isArray(e)) return !1;
  if (!eo(t) || !eo(e)) return t === e;
  const o = Object.keys(t), n = Object.keys(e);
  return o.length === n.length && o.every((i) => De(t[i], e[i]));
}, dn = (t) => {
  if (!(t instanceof HTMLElement || t instanceof SVGElement)) return !1;
  const e = getComputedStyle(t);
  return ["overflow", "overflow-x", "overflow-y"].some((o) => {
    const n = e.getPropertyValue(o);
    return n === "auto" || n === "scroll";
  });
}, oo = (t) => {
  if (!t) return null;
  let e = t.parentElement;
  for (; e; ) {
    if (dn(e)) return e;
    e = e.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, fn = typeof window < "u" ? _o : C, ot = (t) => {
  t.current && (clearTimeout(t.current), t.current = null);
}, pn = "DEFAULT_TOOLTIP_ID", mn = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, hn = wo({ getTooltipData: () => mn });
function ho(t = pn) {
  return go(hn).getTooltipData(t);
}
var It = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, Te = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const vn = ({ forwardRef: t, id: e, className: o, classNameArrow: n, variant: i = "dark", anchorId: r, anchorSelect: l, place: s = "top", offset: c = 10, events: a = ["hover"], openOnClick: p = !1, positionStrategy: f = "absolute", middlewares: w, wrapper: d, delayShow: m = 0, delayHide: v = 0, float: x = !1, hidden: g = !1, noArrow: _ = !1, clickable: A = !1, closeOnEsc: R = !1, closeOnScroll: S = !1, closeOnResize: q = !1, openEvents: N, closeEvents: Q, globalCloseEvents: K, imperativeModeOnly: Z, style: ct, position: G, afterShow: at, afterHide: T, disableTooltip: X, content: F, contentWrapperRef: I, isOpen: D, defaultIsOpen: z = !1, setIsOpen: ht, activeAnchor: $, setActiveAnchor: Ct, border: ae, opacity: ue, arrowColor: de, role: Ae = "tooltip" }) => {
  var Ht;
  const V = it(null), Lt = it(null), nt = it(null), yt = it(null), qt = it(null), [wt, Ee] = j({ tooltipStyles: {}, tooltipArrowStyles: {}, place: s }), [Y, fe] = j(!1), [xt, _t] = j(!1), [k, Kt] = j(null), Xt = it(!1), Yt = it(null), { anchorRefs: Ut, setActiveAnchor: pe } = ho(e), kt = it(!1), [gt, Jt] = j([]), At = it(!1), Nt = p || a.includes("click"), Qt = Nt || (N == null ? void 0 : N.click) || (N == null ? void 0 : N.dblclick) || (N == null ? void 0 : N.mousedown), Dt = N ? { ...N } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !N && Nt && Object.assign(Dt, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const Zt = Q ? { ...Q } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !Q && Nt && Object.assign(Zt, { mouseleave: !1, blur: !1, mouseout: !1 });
  const rt = K ? { ...K } : { escape: R || !1, scroll: S || !1, resize: q || !1, clickOutsideAnchor: Qt || !1 };
  Z && (Object.assign(Dt, { mouseenter: !1, focus: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(Zt, { mouseleave: !1, blur: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(rt, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), fn(() => (At.current = !0, () => {
    At.current = !1;
  }), []);
  const P = (u) => {
    At.current && (u && _t(!0), setTimeout(() => {
      At.current && (ht == null || ht(u), D === void 0 && fe(u));
    }, 10));
  };
  C(() => {
    if (D === void 0) return () => null;
    D && _t(!0);
    const u = setTimeout(() => {
      fe(D);
    }, 10);
    return () => {
      clearTimeout(u);
    };
  }, [D]), C(() => {
    if (Y !== Xt.current) if (ot(qt), Xt.current = Y, Y) at == null || at();
    else {
      const u = ((y) => {
        const b = y.match(/^([\d.]+)(ms|s)$/);
        if (!b) return 0;
        const [, B, W] = b;
        return Number(B) * (W === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      qt.current = setTimeout(() => {
        _t(!1), Kt(null), T == null || T();
      }, u + 25);
    }
  }, [Y]);
  const me = (u) => {
    Ee((y) => De(y, u) ? y : u);
  }, Gt = (u = m) => {
    ot(nt), xt ? P(!0) : nt.current = setTimeout(() => {
      P(!0);
    }, u);
  }, Pt = (u = v) => {
    ot(yt), yt.current = setTimeout(() => {
      kt.current || P(!1);
    }, u);
  }, te = (u) => {
    var y;
    if (!u) return;
    const b = (y = u.currentTarget) !== null && y !== void 0 ? y : u.target;
    if (!(b != null && b.isConnected)) return Ct(null), void pe({ current: null });
    m ? Gt() : P(!0), Ct(b), pe({ current: b }), ot(yt);
  }, jt = () => {
    A ? Pt(v || 100) : v ? Pt() : P(!1), ot(nt);
  }, $t = ({ x: u, y }) => {
    var b;
    const B = { getBoundingClientRect: () => ({ x: u, y, width: 0, height: 0, top: y, left: u, right: u, bottom: y }) };
    Ze({ place: (b = k == null ? void 0 : k.place) !== null && b !== void 0 ? b : s, offset: c, elementReference: B, tooltipReference: V.current, tooltipArrowReference: Lt.current, strategy: f, middlewares: w, border: ae }).then((W) => {
      me(W);
    });
  }, Bt = (u) => {
    if (!u) return;
    const y = u, b = { x: y.clientX, y: y.clientY };
    $t(b), Yt.current = b;
  }, ee = (u) => {
    var y;
    if (!Y) return;
    const b = u.target;
    b.isConnected && (!((y = V.current) === null || y === void 0) && y.contains(b) || [document.querySelector(`[id='${r}']`), ...gt].some((B) => B == null ? void 0 : B.contains(b)) || (P(!1), ot(nt)));
  }, he = to(te, 50), M = to(jt, 50), tt = (u) => {
    M.cancel(), he(u);
  }, h = () => {
    he.cancel(), M();
  }, E = bo(() => {
    var u, y;
    const b = (u = k == null ? void 0 : k.position) !== null && u !== void 0 ? u : G;
    b ? $t(b) : x ? Yt.current && $t(Yt.current) : $ != null && $.isConnected && Ze({ place: (y = k == null ? void 0 : k.place) !== null && y !== void 0 ? y : s, offset: c, elementReference: $, tooltipReference: V.current, tooltipArrowReference: Lt.current, strategy: f, middlewares: w, border: ae }).then((B) => {
      At.current && me(B);
    });
  }, [Y, $, F, ct, s, k == null ? void 0 : k.place, c, f, G, k == null ? void 0 : k.position, x]);
  C(() => {
    var u, y;
    const b = new Set(Ut);
    gt.forEach((O) => {
      X != null && X(O) || b.add({ current: O });
    });
    const B = document.querySelector(`[id='${r}']`);
    B && !(X != null && X(B)) && b.add({ current: B });
    const W = () => {
      P(!1);
    }, ut = oo($), dt = oo(V.current);
    rt.scroll && (window.addEventListener("scroll", W), ut == null || ut.addEventListener("scroll", W), dt == null || dt.addEventListener("scroll", W));
    let H = null;
    rt.resize ? window.addEventListener("resize", W) : $ && V.current && (H = on($, V.current, E, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const et = (O) => {
      O.key === "Escape" && P(!1);
    };
    rt.escape && window.addEventListener("keydown", et), rt.clickOutsideAnchor && window.addEventListener("click", ee);
    const L = [], oe = (O) => {
      Y && (O == null ? void 0 : O.target) === $ || te(O);
    }, vo = (O) => {
      Y && (O == null ? void 0 : O.target) === $ && jt();
    }, We = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], Fe = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(Dt).forEach(([O, vt]) => {
      vt && (We.includes(O) ? L.push({ event: O, listener: tt }) : Fe.includes(O) && L.push({ event: O, listener: oe }));
    }), Object.entries(Zt).forEach(([O, vt]) => {
      vt && (We.includes(O) ? L.push({ event: O, listener: h }) : Fe.includes(O) && L.push({ event: O, listener: vo }));
    }), x && L.push({ event: "pointermove", listener: Bt });
    const ze = () => {
      kt.current = !0;
    }, Ve = () => {
      kt.current = !1, jt();
    };
    return A && !Qt && ((u = V.current) === null || u === void 0 || u.addEventListener("mouseenter", ze), (y = V.current) === null || y === void 0 || y.addEventListener("mouseleave", Ve)), L.forEach(({ event: O, listener: vt }) => {
      b.forEach((Se) => {
        var ne;
        (ne = Se.current) === null || ne === void 0 || ne.addEventListener(O, vt);
      });
    }), () => {
      var O, vt;
      rt.scroll && (window.removeEventListener("scroll", W), ut == null || ut.removeEventListener("scroll", W), dt == null || dt.removeEventListener("scroll", W)), rt.resize ? window.removeEventListener("resize", W) : H == null || H(), rt.clickOutsideAnchor && window.removeEventListener("click", ee), rt.escape && window.removeEventListener("keydown", et), A && !Qt && ((O = V.current) === null || O === void 0 || O.removeEventListener("mouseenter", ze), (vt = V.current) === null || vt === void 0 || vt.removeEventListener("mouseleave", Ve)), L.forEach(({ event: Se, listener: ne }) => {
        b.forEach((yo) => {
          var Oe;
          (Oe = yo.current) === null || Oe === void 0 || Oe.removeEventListener(Se, ne);
        });
      });
    };
  }, [$, E, xt, Ut, gt, N, Q, K, Nt, m, v]), C(() => {
    var u, y;
    let b = (y = (u = k == null ? void 0 : k.anchorSelect) !== null && u !== void 0 ? u : l) !== null && y !== void 0 ? y : "";
    !b && e && (b = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`);
    const B = new MutationObserver((W) => {
      const ut = [], dt = [];
      W.forEach((H) => {
        if (H.type === "attributes" && H.attributeName === "data-tooltip-id" && (H.target.getAttribute("data-tooltip-id") === e ? ut.push(H.target) : H.oldValue === e && dt.push(H.target)), H.type === "childList") {
          if ($) {
            const et = [...H.removedNodes].filter((L) => L.nodeType === 1);
            if (b) try {
              dt.push(...et.filter((L) => L.matches(b))), dt.push(...et.flatMap((L) => [...L.querySelectorAll(b)]));
            } catch {
            }
            et.some((L) => {
              var oe;
              return !!(!((oe = L == null ? void 0 : L.contains) === null || oe === void 0) && oe.call(L, $)) && (_t(!1), P(!1), Ct(null), ot(nt), ot(yt), !0);
            });
          }
          if (b) try {
            const et = [...H.addedNodes].filter((L) => L.nodeType === 1);
            ut.push(...et.filter((L) => L.matches(b))), ut.push(...et.flatMap((L) => [...L.querySelectorAll(b)]));
          } catch {
          }
        }
      }), (ut.length || dt.length) && Jt((H) => [...H.filter((et) => !dt.includes(et)), ...ut]);
    });
    return B.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      B.disconnect();
    };
  }, [e, l, k == null ? void 0 : k.anchorSelect, $]), C(() => {
    E();
  }, [E]), C(() => {
    if (!(I != null && I.current)) return () => null;
    const u = new ResizeObserver(() => {
      setTimeout(() => E());
    });
    return u.observe(I.current), () => {
      u.disconnect();
    };
  }, [F, I == null ? void 0 : I.current]), C(() => {
    var u;
    const y = document.querySelector(`[id='${r}']`), b = [...gt, y];
    $ && b.includes($) || Ct((u = gt[0]) !== null && u !== void 0 ? u : y);
  }, [r, gt, $]), C(() => (z && P(!0), () => {
    ot(nt), ot(yt);
  }), []), C(() => {
    var u;
    let y = (u = k == null ? void 0 : k.anchorSelect) !== null && u !== void 0 ? u : l;
    if (!y && e && (y = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), y) try {
      const b = Array.from(document.querySelectorAll(y));
      Jt(b);
    } catch {
      Jt([]);
    }
  }, [e, l, k == null ? void 0 : k.anchorSelect]), C(() => {
    nt.current && (ot(nt), Gt(m));
  }, [m]);
  const U = (Ht = k == null ? void 0 : k.content) !== null && Ht !== void 0 ? Ht : F, Et = Y && Object.keys(wt.tooltipStyles).length > 0;
  return xo(t, () => ({ open: (u) => {
    if (u != null && u.anchorSelect) try {
      document.querySelector(u.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${u.anchorSelect}" is not a valid CSS selector`);
    }
    Kt(u ?? null), u != null && u.delay ? Gt(u.delay) : P(!0);
  }, close: (u) => {
    u != null && u.delay ? Pt(u.delay) : P(!1);
  }, activeAnchor: $, place: wt.place, isOpen: !!(xt && !g && U && Et) })), xt && !g && U ? St.createElement(d, { id: e, role: Ae, className: Ne("react-tooltip", It.tooltip, Te.tooltip, Te[i], o, `react-tooltip__place-${wt.place}`, It[Et ? "show" : "closing"], Et ? "react-tooltip__show" : "react-tooltip__closing", f === "fixed" && It.fixed, A && It.clickable), onTransitionEnd: (u) => {
    ot(qt), Y || u.propertyName !== "opacity" || (_t(!1), Kt(null), T == null || T());
  }, style: { ...ct, ...wt.tooltipStyles, opacity: ue !== void 0 && Et ? ue : void 0 }, ref: V }, U, St.createElement(d, { className: Ne("react-tooltip-arrow", It.arrow, Te.arrow, n, _ && It.noArrow), style: { ...wt.tooltipArrowStyles, background: de ? `linear-gradient(to right bottom, transparent 50%, ${de} 50%)` : void 0 }, ref: Lt })) : null;
}, yn = ({ content: t }) => St.createElement("span", { dangerouslySetInnerHTML: { __html: t } }), wn = St.forwardRef(({ id: t, anchorId: e, anchorSelect: o, content: n, html: i, render: r, className: l, classNameArrow: s, variant: c = "dark", place: a = "top", offset: p = 10, wrapper: f = "div", children: w = null, events: d = ["hover"], openOnClick: m = !1, positionStrategy: v = "absolute", middlewares: x, delayShow: g = 0, delayHide: _ = 0, float: A = !1, hidden: R = !1, noArrow: S = !1, clickable: q = !1, closeOnEsc: N = !1, closeOnScroll: Q = !1, closeOnResize: K = !1, openEvents: Z, closeEvents: ct, globalCloseEvents: G, imperativeModeOnly: at = !1, style: T, position: X, isOpen: F, defaultIsOpen: I = !1, disableStyleInjection: D = !1, border: z, opacity: ht, arrowColor: $, setIsOpen: Ct, afterShow: ae, afterHide: ue, disableTooltip: de, role: Ae = "tooltip" }, Ht) => {
  const [V, Lt] = j(n), [nt, yt] = j(i), [qt, wt] = j(a), [Ee, Y] = j(c), [fe, xt] = j(p), [_t, k] = j(g), [Kt, Xt] = j(_), [Yt, Ut] = j(A), [pe, kt] = j(R), [gt, Jt] = j(f), [At, Nt] = j(d), [Qt, Dt] = j(v), [Zt, rt] = j(null), [P, me] = j(null), Gt = it(D), { anchorRefs: Pt, activeAnchor: te } = ho(t), jt = (M) => M == null ? void 0 : M.getAttributeNames().reduce((tt, h) => {
    var E;
    return h.startsWith("data-tooltip-") && (tt[h.replace(/^data-tooltip-/, "")] = (E = M == null ? void 0 : M.getAttribute(h)) !== null && E !== void 0 ? E : null), tt;
  }, {}), $t = (M) => {
    const tt = { place: (h) => {
      var E;
      wt((E = h) !== null && E !== void 0 ? E : a);
    }, content: (h) => {
      Lt(h ?? n);
    }, html: (h) => {
      yt(h ?? i);
    }, variant: (h) => {
      var E;
      Y((E = h) !== null && E !== void 0 ? E : c);
    }, offset: (h) => {
      xt(h === null ? p : Number(h));
    }, wrapper: (h) => {
      var E;
      Jt((E = h) !== null && E !== void 0 ? E : f);
    }, events: (h) => {
      const E = h == null ? void 0 : h.split(" ");
      Nt(E ?? d);
    }, "position-strategy": (h) => {
      var E;
      Dt((E = h) !== null && E !== void 0 ? E : v);
    }, "delay-show": (h) => {
      k(h === null ? g : Number(h));
    }, "delay-hide": (h) => {
      Xt(h === null ? _ : Number(h));
    }, float: (h) => {
      Ut(h === null ? A : h === "true");
    }, hidden: (h) => {
      kt(h === null ? R : h === "true");
    }, "class-name": (h) => {
      rt(h);
    } };
    Object.values(tt).forEach((h) => h(null)), Object.entries(M).forEach(([h, E]) => {
      var U;
      (U = tt[h]) === null || U === void 0 || U.call(tt, E);
    });
  };
  C(() => {
    Lt(n);
  }, [n]), C(() => {
    yt(i);
  }, [i]), C(() => {
    wt(a);
  }, [a]), C(() => {
    Y(c);
  }, [c]), C(() => {
    xt(p);
  }, [p]), C(() => {
    k(g);
  }, [g]), C(() => {
    Xt(_);
  }, [_]), C(() => {
    Ut(A);
  }, [A]), C(() => {
    kt(R);
  }, [R]), C(() => {
    Dt(v);
  }, [v]), C(() => {
    Gt.current !== D && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [D]), C(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: D === "core", disableBase: D } }));
  }, []), C(() => {
    var M;
    const tt = new Set(Pt);
    let h = o;
    if (!h && t && (h = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), h) try {
      document.querySelectorAll(h).forEach((y) => {
        tt.add({ current: y });
      });
    } catch {
      console.warn(`[react-tooltip] "${h}" is not a valid CSS selector`);
    }
    const E = document.querySelector(`[id='${e}']`);
    if (E && tt.add({ current: E }), !tt.size) return () => null;
    const U = (M = P ?? E) !== null && M !== void 0 ? M : te.current, Et = new MutationObserver((y) => {
      y.forEach((b) => {
        var B;
        if (!U || b.type !== "attributes" || !(!((B = b.attributeName) === null || B === void 0) && B.startsWith("data-tooltip-"))) return;
        const W = jt(U);
        $t(W);
      });
    }), u = { attributes: !0, childList: !1, subtree: !1 };
    if (U) {
      const y = jt(U);
      $t(y), Et.observe(U, u);
    }
    return () => {
      Et.disconnect();
    };
  }, [Pt, te, P, e, o]), C(() => {
    T != null && T.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), z && !Ge("border", `${z}`) && console.warn(`[react-tooltip] "${z}" is not a valid \`border\`.`), T != null && T.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), ht && !Ge("opacity", `${ht}`) && console.warn(`[react-tooltip] "${ht}" is not a valid \`opacity\`.`);
  }, []);
  let Bt = w;
  const ee = it(null);
  if (r) {
    const M = r({ content: (P == null ? void 0 : P.getAttribute("data-tooltip-content")) || V || null, activeAnchor: P });
    Bt = M ? St.createElement("div", { ref: ee, className: "react-tooltip-content-wrapper" }, M) : null;
  } else V && (Bt = V);
  nt && (Bt = St.createElement(yn, { content: nt }));
  const he = { forwardRef: Ht, id: t, anchorId: e, anchorSelect: o, className: Ne(l, Zt), classNameArrow: s, content: Bt, contentWrapperRef: ee, place: qt, variant: Ee, offset: fe, wrapper: gt, events: At, openOnClick: m, positionStrategy: Qt, middlewares: x, delayShow: _t, delayHide: Kt, float: Yt, hidden: pe, noArrow: S, clickable: q, closeOnEsc: N, closeOnScroll: Q, closeOnResize: K, openEvents: Z, closeEvents: ct, globalCloseEvents: G, imperativeModeOnly: at, style: T, position: X, isOpen: F, defaultIsOpen: I, border: z, opacity: ht, arrowColor: $, setIsOpen: Ct, afterShow: ae, afterHide: ue, disableTooltip: de, activeAnchor: P, setActiveAnchor: (M) => me(M), role: Ae };
  return St.createElement(vn, { ...he });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (t) => {
  t.detail.disableCore || Qe({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), t.detail.disableBase || Qe({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const gn = (t) => {
  const { children: e, eventType: o = "click", showCloseButton: n = !1, className: i, ...r } = t, [l, s] = j(r.isOpen);
  return /* @__PURE__ */ re.jsx(
    wn,
    {
      ...r,
      className: He(
        "!pointer-events-auto min-w-100 max-w-[280px] !rounded-6 !bg-fill-neutral-main !p-4 !typography-body-12-regular-multiline",
        i
      ),
      classNameArrow: He("!size-[8.5px]", t.classNameArrow),
      events: [o],
      globalCloseEvents: {
        clickOutsideAnchor: !n
      },
      isOpen: l,
      opacity: 1,
      setIsOpen: s,
      children: /* @__PURE__ */ re.jsxs("div", { className: "flex", children: [
        /* @__PURE__ */ re.jsx("div", { className: "p-8", children: e }),
        !!n && /* @__PURE__ */ re.jsx(
          Eo,
          {
            className: "size-32",
            icon: /* @__PURE__ */ re.jsx(Ao, {}),
            onClick: () => {
              s(!1);
            },
            size: "small",
            theme: "transparent"
          }
        )
      ] })
    }
  );
};
gn.displayName = "NDS.Tooltip";
export {
  gn as T
};
